import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/events/awaiting-review')({
  beforeLoad: () => {
    throw redirect({
      to: '/events',
      search: { queue: 'underReview', view: 'list' },
      replace: true,
    });
  },
});
